<template>
    <div>
        <!-- Modal Rastreabilidade Exame-->
        <div class="modal fade" id="rastreabilidadeExameModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fa-solid fa-stopwatch mr-2"></i>
                            Rastreabilidade 
                            <span v-if="atp">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ atp.procedimento.st_procedimento }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="atend" class="alert alert-dark">
                            <div class="lead">{{ atend.paciente.st_nome }}</div>
                            <div v-if="atend.marcacao && atend.marcacao.unidade_operacao">
                                {{ atend.marcacao.unidade_operacao.st_nome }}</div>
                            <div>
                                #{{ atend.id_atendimento }}
                                <span v-if="atend.marcacao && atend.marcacao.st_id_externo">
                                    <i class="fas fa-caret-right mx-2"></i>
                                    {{ atend.marcacao.st_id_externo }}
                                </span>
                            </div>
                            <div>
                                {{ $util.getFormatDate(atend.dt_inicio) }}
                                {{ atend.dt_inicio.substr(11,5) }}
                            </div>
                        </div>

                        <az-empty-state v-if="!dados" />

                        <template v-else>
                            <table class="table table-sm small">
                                <thead>
                                    <tr>
                                        <th>Data</th>
                                        <th>Usuário</th>
                                        <th>Evento</th>
                                        <th>Amostra</th>
                                        <th>Informação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(rastro, irx) in dados.lista" :key="irx" :class="rastro.cor ? 'table-' + rastro.cor : ''">
                                        <td>
                                            {{ $util.getFormatDate(rastro.data) }}
                                            {{ rastro.data.substr(11,5) }}
                                        </td>
                                        <td>{{ rastro.usuario }}</td>
                                        <td>{{ rastro.evento }}</td>
                                        <td>{{ rastro.amostra }}</td>
                                        <td>{{ rastro.obs }}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <template v-if="false">
                                <pre>{{ dados }}</pre>
                                <hr>
                                <pre>{{ atp }}</pre>
                                <hr>
                                <pre>{{ atend }}</pre>
                            </template>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
  components: { AzEmptyState },
    data() { 
        return { 
            dados: null, 
            atp: null, 
            atend: null, 
        }
    },

    methods: { 
        abrir(atp, atend = null) { 

            this.dados = null;
            this.atp = _.cloneDeep(atp);
            this.atend = _.cloneDeep(atend);

            $('#rastreabilidadeExameModal').modal('show');

            this.$util.load(this, { 
                service: 'amostras',
                func: 'rastreabilidade_procedimento',
                parms: { 
                    id_atendimento_procedimento: atp.id_atendimento_procedimento, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });

        }
    }
}
</script>
